import { __assign } from "tslib";
import { useContext } from 'react';
import { createDomContext } from '../hooks/dom-context';
export var AppLayoutDomContext = createDomContext('app-layout-context', {
    stickyOffsetTop: 0,
    stickyOffsetBottom: 0
});
export function useAppLayoutContext() {
    var context = useContext(AppLayoutDomContext.context);
    return __assign({}, context);
}
